import Box from '@mui/material/Box';
import { addYears, subYears } from 'date-fns';
import { useEffect, useState } from 'react';
import { TextField } from '../../Inputs';
import { useDateRangeTexts } from '../useDateRangeTexts';
import { parseInputRange, toInputFormat } from './inputFormat';
import { usePicker } from './PickerProvider';
import { TimeZoneHint } from './TimeZoneHint';

export function Fields() {
  const texts = useDateRangeTexts();
  const { draftValue, precision, setDraftValue, timeZone } = usePicker();
  const [fromText, setFromText] = useState(
    toInputFormat(draftValue.from, precision)
  );
  const [toText, setToText] = useState(toInputFormat(draftValue.to, precision));
  const inputStep = precision === 'second' ? 1 : 60;
  const minDate = toInputFormat(subYears(new Date(), 3), precision);
  const maxDate = toInputFormat(addYears(new Date(), 1), precision);

  // Keep editable strings aligned when presets, step controls, or max-duration
  // clamping update the draft range outside the focused input.
  useEffect(() => {
    setFromText(toInputFormat(draftValue.from, precision));
    setToText(toInputFormat(draftValue.to, precision));
  }, [draftValue, precision]);

  const commit = (from: string, to: string) => {
    const range = parseInputRange({ from, to, timeZone });

    if (range) {
      setDraftValue(range);
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', flexFlow: 'wrap', gap: 1 }}>
        <TextField
          label={texts.picker.fields.from.label}
          margin="none"
          name="from"
          onChange={(event) => setFromText(event.target.value)}
          size="medium"
          sx={{ width: '200px' }}
          type="datetime-local"
          value={fromText}
          slotProps={{
            htmlInput: {
              max: toText,
              min: minDate,
              onBlur: () => commit(fromText, toText),
              required: true,
              step: inputStep,
            },
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextField
          label={texts.picker.fields.to.label}
          margin="none"
          name="to"
          onChange={(event) => setToText(event.target.value)}
          size="medium"
          sx={{ width: '200px' }}
          type="datetime-local"
          value={toText}
          slotProps={{
            htmlInput: {
              max: maxDate,
              min: fromText,
              onBlur: () => commit(fromText, toText),
              required: true,
              step: inputStep,
            },
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Box>
      <Box mt={2}>
        <TimeZoneHint timeZone={timeZone} />
      </Box>
    </div>
  );
}
